import { Injectable } from '@angular/core';
import { Transaction } from '@app/transactions/transaction';
import { Service, IAttributes } from 'ngx-jsonapi';

@Injectable({
    providedIn: 'root'
})
export class TransactionsService extends Service<Transaction> {
    public resource: typeof Transaction = Transaction;
    public type: string = 'transactions';
    public ttl: number = 60;

    public constructor() {
        super();
        this.register();
    }

    public parseToServer(attributes: IAttributes): void {
        if (attributes.__operation === 'send') {
            attributes.amount1 = 0;
        } else if (attributes.__operation === 'receive') {
            attributes.amount2 = 0;
        }
    }
}
